const EntityRoleType = {
  MANAGER: 1,
  STAFF: 2,
  ACCOUNTANT: 3
}

export default EntityRoleType
